import React from 'react';
import classNames from 'classnames/bind';
import { Preloader } from 'components';
import { PopupContentWrapper } from '../../../../components';
import { ConnectionTitle } from '../Connection/connected';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const Loading = () => (
  <PopupContentWrapper>
    <ConnectionTitle />
    <Preloader className={cx('preloader')} size="80" />
  </PopupContentWrapper>
);
